<template>
  <div class="about history1">
    <h2 class="about-title">黎明期<span class="about-title__year">1961-1970</span></h2>

    <!-- <div><Carousel></Carousel></div> -->

    <div class="content1 column section">
      <p>日本におけるモーターサイクルスポーツは、明治終わりにはすでに開催が始まっており、大正から昭和初期にかけて 開催が続いていましたが、戦時下には休止を余儀なくされました。戦後、はじめて開催されたレースは、1953年３月21日に愛知県で開催された全日本選抜優良軽オートバイ旅行賞パレード（名古屋TTレース）だと言われています。
      その後、1953年からは富士オートレースが毎日新聞社の主催により富士山を舞台として、年１回開催され多くの人気を集めました。1955年からは、浅間高原レース（後の浅間火山レース）も開始され、日本のモーターサイクルレースは大きく花開くこととなりました。
      この浅間レースは、各地域のモーターサイクル愛好会の連合組織「全日本モーターサイクルクラブ連盟（MCFAJ）」が主催していました</p>
      <figure><img src="/img/1963_01_01.jpg" alt="ライディング創刊号"><figcaption>MFJ機関誌「ライディング」の創刊は1963年3月。モトクロスの豪快な走行シーンが表紙を飾った。</figcaption></figure>
    </div>

    <div class="content2 img-content">
      <div class="img-content__bg">
        <div class="img-content__wrap">
          <div class="img-content__text">
            <h3>世界選手権日本グランプリ開幕</h3>
            <p>1963年、世界選手権日本グランプリが鈴鹿サーキットで開催され、日本のモーターサイクルスポーツファンは初めて海外トップレベルのレースに触れることになりました。
            観客席は大勢の観客で、まさに立錐の余地がないほどに埋まり、世界トップレベルのマシン、ライダーが織りなす激闘に酔いしれていました。</p>
          </div>
          <Carousel :slides="slides"></Carousel>
        </div>
      </div>
    </div>
    <div class="content3 section">
      <div class="content3__wrap">
        <h3>日本モーターサイクルレース協会（MFJ）が設立</h3>
        <div class="column">
          <div>
            <p>次に目が向くのは海外レースとなりますが、当時も現在も、海外レース参戦にはFIMに加盟する各国協会の承認が必要で、当時に日本では正式にFIMへ加盟、活動している団体がなかったことから、1961年に日本モーターサイクルレース協会（MFJ）が設立されました。</p>
            <p>この年には1959年のホンダ、1960年のスズキに続き、ヤマハも世界選手権ロードレースに参戦。さらに、高橋国光選手が西ドイツGPの250ccクラスで日本人選手としてはじめて世界選手権に優勝、ホンダが世界選手権125cc、250ccのメーカータイトルを獲得するなど、輝かしい結果を残した年でもあります。</p>
            <p>1962年には三重県に鈴鹿サーキットが完成し、第１回全日本ロードレース選手権大会が開催されます。<br>
            1963年、MFJは協会名を日本モーターサイクル協会に変更、世界選手権シリーズの一戦として第１回日本グランプリロードレース大会が鈴鹿サーキットで開催されました。この年のマン島TTレースでは、伊藤光夫選手が日本人初の優勝を飾っています。</p>
          </div>
          <figure class="about-01__image">
            <img src="/img/about-1960_02.jpg" alt="ライディング創刊号">
            <figcaption>1960年代には優秀選手をヨーロッパへ派遣する制度もあり、多くの若手有望選手が本場で腕を磨きました</figcaption>
          </figure>
        </div>
      </div>
    </div>
    <div class="content4 section column">
      <img src="/img/about-1960_03.jpg" alt="">
      <div>
        <p>1964年には第１回モトクロス日本グランプリ大会を群馬県相馬ヶ原で開催。1966年には第１回の最優秀選手として第３回モトクロス日本グランプリ大会アマチュア部門で優秀な成績を修めた三谷正次選手をヨーロッパへ派遣しました。</p>
        <p>1967年に、現在にも続くMFJ国内競技規則を確立するとともに、全日本選手権にランキング制度を導入。その後、モトクロスが一大ブームを迎え、初めてのテレビ中継も行われるなど、モーターサイクルスポーツは70年代に向け、さらなる盛り上がりを見せることになります。</p>
      </div>
    </div>
    <div class="content5 img-content">
      <div class="img-content__bg">
        <div class="img-content__wrap">
          <div>
            <h3>モトクロス日本グランプリ開幕</h3>
            <p>ロードレースとともに、1960年代のモーターサイクルブームを彩ったのがモトクロスです。６０年代後半には、一大ブームを迎えることとなります。<br>
            スライド画像は1967年に開催された第4回モトクロスGPの模様と当時のモトクロッサー達です。</p>
          </div>
          <img src="/img/about-1960_04.jpg" alt="モトクロス日本グランプリ開幕">
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import Carousel from '@/components/Carousel';
export default {
  name: "tab1964",
  components: {
    Carousel,
  },
  data: () => {
      return {
        slides: [
            {url: '/img/about-1960_01.jpg', alt: 'img1'},
            {url: '/img/about-1960_01_2.jpg', alt: 'img2'}
        ],
      }
  },
};
</script>
 
<style lang="scss">
.history1 {
  figure {
    margin: 0;
  }
  figcaption {
    font-size: 12px;
    margin-top: 10px;
  }
  .column {
    display: flex;
    justify-content: flex-start;
    > * {
      width: 48%;
    }
    > *:first-child {
      margin-right: 2%;
    }
    @media(max-width: 1200px) {
      display: block;
      > * {
        width: 100%;
      }
      > *:first-child {
        margin-right: 0;
        margin-bottom: 20px;
      }
    }
  }
  .content1 {
    > p {
      width: auto;
    }
    > figure {
      max-width: 240px;
      flex: 0 0 auto;
      width: 100%;
      padding: 15px;
      border: 1px solid #ccc;
    }
  }
  .content2 {
    background: url(/img/about-1960-back01.jpg) center center / cover no-repeat;
  }
  .content3{
    display: flex;
    align-items: flex-start;
    margin-bottom: 30px;
    h3 {
      margin-top: 40px;
      margin-bottom: 10px;
    }
    &__image{
      margin-left: 20px;
      margin-right: 0;
      padding: 20px;
      border: solid 1px #dadada;
      img{
        width: 240px;
      }
      figcaption{
        font-size: 12px;
      }
    }
    .column {
      align-items: flex-start;
      > * {
        width: auto;
      }
      p {
        margin:0 0 10px;
      }
      figure {
        max-width: 240px;
        flex: 1 0 auto;
        width: 100%;
        border: 1px solid #ccc;
        padding: 15px;
      }
    }
  }
  .content4{
    img{
      margin-right: 30px;
    }
  }
  .content5 {
    background: url(/img/about-1960_04.jpg) center center / cover no-repeat;
    .img-content__wrap {
      flex-wrap: initial;
    }
  }
}

</style>